<script lang="ts" setup></script>

<template>
  <section class="banner" role="banner">
    <div class="banner__wrap">
      <div class="banner__title">
        <div class="new">New</div>
        <div class="banner__text">디포스트는 오늘도</div>
        <div class="banner__text">확장하고 있습니다</div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.banner {
  @apply py-36;
  @apply desktop:py-28 mobile:py-[73px];

  background-color: #005bfe;

  &__text {
    color: white;
    padding: 4px 0;
  }
  &__wrap {
    @apply flex flex-col gap-14;
    @apply desktop:gap-20;
    @apply desktop:w-[65%] desktop:h-[560px];
    @apply mobile:w-[90%] mobile:h-[335px];
    background-image: linear-gradient(to right, #ffffff, #005bfe);
    border-top-right-radius: 300px;
    border-bottom-right-radius: 300px;
  }
  &__title {
    // @apply w-fit mx-auto;
    @apply h-fit my-auto absolute mobile:mx-auto mobile:w-full;
    @apply desktop:right-[24%] desktop:pt-[181px] mobile:pt-[122px];
    @apply text-center font-black text-3xl leading-[1.5];
    @apply desktop:text-5xl desktop:leading-[1.5];
  }
  &__button {
    @apply w-fit h-fit mx-auto px-10 py-4 drop-shadow-lg;
    @apply rounded-[14px] bg-white text-[#16856a] font-bold;
    @apply desktop:text-3xl desktop:px-20 desktop:py-6;

    &:hover {
      @apply text-opacity-40 transition-all;
    }
  }
}

.new {
  @apply bg-white px-3 py-2 w-fit text-primary text-base font-bold rounded-[36px];
  @apply ml-auto desktop:relative desktop:top-2 desktop:left-10;
  @apply mobile:absolute mobile:top-20 mobile:left-[75%];
}
</style>
